import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { GeneralSectionComponent } from "../../../components/courses-components/general-section/general-section.component";
import { StructureSectionComponent } from "../../../components/courses-components/structure-section/structure-section.component";
import { AchivementsSectionComponent } from "../../../components/courses-components/achivements-section/achivements-section.component";
import { PricingSectionComponent } from "../../../components/courses-components/pricing-section/pricing-section.component";
import { CommunicationComponent } from "../../../components/courses-components/communication/communication.component";
import { AnalyticsSectionComponent } from "../../../components/courses-components/analytics-section/analytics-section.component";
import { RouterModule, ActivatedRoute } from '@angular/router';
import { CourseApiServiceService } from '../course-api-service.service';
import { environment } from '../../../../environments/environment';
import { Store } from '@ngrx/store';
import { emptyCourseAllData, setCourseAllData } from '../store/course.action';
import { Observable } from 'rxjs';
import { courseDetails, coursePrice } from '../store/course.selector';
import { courseDetails as courseDetailsModal } from '../store/course.modal';
import { FilterBaseAccessService } from '../../../auth/filterbase-access';

@Component({
  selector: 'app-course-details',
  standalone: true,
  imports: [CommonModule, GeneralSectionComponent, StructureSectionComponent, AchivementsSectionComponent, PricingSectionComponent, CommunicationComponent, AnalyticsSectionComponent, RouterModule],
  templateUrl: './course-details.component.html',
  styleUrl: './course-details.component.css'
})
export class CourseDetailsComponent {

  iswatchaccess:boolean=false;
  islistaccess:boolean=true;
  isdetailaccess:boolean=false;
  thumbnail = 'https://goedu.ac/wp-content/uploads/2024/11/GoEdu-course-thumbnail.webp';

  currentTab = 'general';
  tabs = [
    { name: 'general', value: 'general' },
    { name: 'structure', value: 'structure' },
    { name: 'achivements', value: 'achivements' },
    { name: 'pricing', value: 'pricing' },
    { name: 'communication', value: 'communication' },
    { name: 'analytics', value: 'analytics' },
  ]
  courseDetails: any
  courseDetails$: Observable<courseDetailsModal | null>
  coursePrice$: Observable<any>
  courseId: any
  mediaBaseUrl=environment.mediaBaseUrl

  constructor(access:FilterBaseAccessService, private courseApiService: CourseApiServiceService, private route: ActivatedRoute,private store:Store) {
    this.courseId = this.route.snapshot.paramMap.get('id');
    this.courseDetails$ = this.store.select(courseDetails);
    this.coursePrice$ = this.store.select(coursePrice);
    this.iswatchaccess=access.checkaccessforfiltersandactions("watch course");
    this.islistaccess=access.checkaccessforfiltersandactions("course list");
    this.isdetailaccess=access.checkaccessforfiltersandactions("course details");
  }

  ngOnInit(): void {
    this.getData(this.courseId);
  }

  getData(id: any) {
   this.courseApiService.getAllCourses(undefined, undefined).subscribe({
      next: (list: any) => {
        const item = Array.isArray(list?.data)
          ? list.data.find((x: any) => String(x?.id) === String(id))
          : null;

        const masterCourseId = item?.master_course_id ?? id;

        this.courseApiService.getCourseFullDetails(masterCourseId).subscribe({
          next: (res: any) => {
            this.courseDetails = res.course_details.data ?? {};
            this.setDataStore(res, masterCourseId);
          },
          error: (err: any) => {
            console.log(err);
          }
        });
      },
      error: (err: any) => {
        this.courseApiService.getCourseFullDetails(id).subscribe({
          next: (res: any) => {
            this.courseDetails = res.course_details.data ?? {};
            this.setDataStore(res);
          },
          error: (err2: any) => console.log(err2)
        });
      }
    });
  }

  setDataStore(data: any, masterCourseId?: any) {
    let type = this.courseDetails?.course_type === 1 ? 'video' : this.courseDetails?.course_type === 2 ? 'flashcard' : null;

    const courseDetailsData = data.course_details?.data ?? {};
    const directCoursePrice =
      data?.course_price?.data?.course_price ??
      data?.course_price?.data ??
      data?.course_price;

    const masterPriceDetail =
      data?.course_price?.data?.master_course_price_detail ??
      data?.course_price?.master_course_price_detail ??
      data?.master_course_price_detail ??
      data?.course_details?.data?.master_course_price_detail;

    const fallbackMasterPrice = masterPriceDetail?.price;

    const hasDirectPriceArray = Array.isArray(directCoursePrice) && directCoursePrice.length > 0;
    const normalizedCoursePrice = hasDirectPriceArray
      ? directCoursePrice
      : Array.isArray(fallbackMasterPrice)
        ? fallbackMasterPrice
        : fallbackMasterPrice
          ? [fallbackMasterPrice]
          : Array.isArray(directCoursePrice)
            ? directCoursePrice
            : directCoursePrice
              ? [directCoursePrice]
              : [];

    const courseDetailsWithMaster = {
      ...courseDetailsData,
      master_course_price_detail: courseDetailsData.master_course_price_detail ?? masterPriceDetail,
    };

    const dispactBody = {
      course_id: masterCourseId ?? this.courseId,
      course_type: type ?? '',
      course_details: courseDetailsWithMaster,
      course_structure: data.course_structure?.data ?? [],
      course_achievements: data.course_achievements?.data ?? null,
      course_price: normalizedCoursePrice,
    };

    this.store.dispatch(setCourseAllData({ data: dispactBody }));
  }

  ngOnDestroy() {
    this.store.dispatch(emptyCourseAllData());
  }


}
